/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceDefinitionNode
 */
export interface ServiceDefinitionNode {
    /**
     * 
     * @type {string}
     * @memberof ServiceDefinitionNode
     */
    serviceDefinitionId?: string;
    /**
     * Child service definitions in the hierarchy
     * @type {Array<ServiceDefinitionNode>}
     * @memberof ServiceDefinitionNode
     */
    children?: Array<ServiceDefinitionNode>;
}

/**
 * Check if a given object implements the ServiceDefinitionNode interface.
 */
export function instanceOfServiceDefinitionNode(value: object): value is ServiceDefinitionNode {
    return true;
}

export function ServiceDefinitionNodeFromJSON(json: any): ServiceDefinitionNode {
    return ServiceDefinitionNodeFromJSONTyped(json, false);
}

export function ServiceDefinitionNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceDefinitionNode {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceDefinitionId': json['serviceDefinitionId'] == null ? undefined : json['serviceDefinitionId'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(ServiceDefinitionNodeFromJSON)),
    };
}

export function ServiceDefinitionNodeToJSON(json: any): ServiceDefinitionNode {
    return ServiceDefinitionNodeToJSONTyped(json, false);
}

export function ServiceDefinitionNodeToJSONTyped(value?: ServiceDefinitionNode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceDefinitionId': value['serviceDefinitionId'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(ServiceDefinitionNodeToJSON)),
    };
}

